// Our main CSS
import '../css/app.css'

//Our main JS
import './menu.js'
import './quantity.js'
import './frontPageSlider.js'

/**
 * 🦄: Now do your magic.
 */

// layzyload and/or play/pause inline videos when they are in/out of view
const autoplaying_videos = document.querySelectorAll('video[playsinline]')

if (autoplaying_videos?.length) {
  ;(async () => {
    const { default: handleVideos } = await import('./modules/inline-videos')
    handleVideos(autoplaying_videos)
  })()
}

/**
 * ⛷️: Alpine.js
 */
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

/**
 * 🌈 Swiper.js
 */

import Swiper from 'swiper'
import { Autoplay, Pagination, Scrollbar } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import 'swiper/css/autoplay'

// Products slider (existing)
const swiper = new Swiper('.products-container', {
  scrollbar: {
    el: '.swiper-scrollbar',
    hide: false,
    draggable: true
  },
  modules: [Autoplay, Scrollbar],
  slidesPerView: 1.2,
  autoplay: {
    delay: 2000
  },
  grabCursor: true,
  speed: 2000,
  loop: false,
  breakpoints: {
    640: { slidesPerView: 1.2, spaceBetween: 10 },
    768: { slidesPerView: 2.2, spaceBetween: 10 },
    1024: { slidesPerView: 3.2, spaceBetween: 10 },
    1400: { slidesPerView: 4.2, spaceBetween: 10 }
  }
})


/**
 * Create navigation arrows for WooCommerce product gallery thumbnails
 * @param {HTMLElement | null} thumbsNav - The parent thumbnails element
 */
function createWooGalleryThumbnailsNavs(thumbsNav) {
  if (!thumbsNav) {
    return
  } // Early return if thumbsNav is null

  const navWrapper = document.createElement('div')
  navWrapper.className = 'thumbnails-nav-wrapper'
  navWrapper.style.position = 'relative'

  const prevArrow = document.createElement('div')
  prevArrow.className = 'thumb-nav-arrow thumb-prev'
  prevArrow.style.cssText =
    'position: absolute; left: 8px; top: 50%; transform: translateY(-50%); z-index: 10; width: 32px; height: 32px; background: rgba(0,0,0,0.8); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; visibility: visible; font-family: FontAwesome; font-size: 14px;'
  prevArrow.innerHTML = '&#xf060;' // left arrow

  const nextArrow = document.createElement('div')
  nextArrow.className = 'thumb-nav-arrow thumb-next'
  nextArrow.style.cssText =
    'position: absolute; right: 8px; top: 50%; transform: translateY(-50%); z-index: 10; width: 32px; height: 32px; background: rgba(0,0,0,0.8); color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; visibility: visible; font-family: FontAwesome; font-size: 14px;'
  nextArrow.innerHTML = '&#xf061;' // right arrow

  // Wrap thumbnails and add arrows
  thumbsNav.parentNode.insertBefore(navWrapper, thumbsNav)
  navWrapper.appendChild(prevArrow)
  navWrapper.appendChild(thumbsNav)
  navWrapper.appendChild(nextArrow)

  // Arrow click functionality
  prevArrow.addEventListener('click', () => {
    thumbsNav.scrollBy({ left: -200, behavior: 'smooth' })
  })

  nextArrow.addEventListener('click', () => {
    thumbsNav.scrollBy({ left: 200, behavior: 'smooth' })
  })
}

// WooCommerce Product Gallery
setTimeout(() => {
  const productGallery = document.querySelector('.woocommerce-product-gallery')
  if (productGallery) {
    const thumbsNav = productGallery.querySelector('.flex-control-nav.flex-control-thumbs')

    if (thumbsNav) {
      const images = thumbsNav.querySelectorAll('li')
      const isMobile = window.innerWidth < 768
      const threshold = isMobile ? 4 : 6 // 4 for mobile, 6 for desktop

      if (images.length > threshold) {
        createWooGalleryThumbnailsNavs(thumbsNav)
      }

      let isDown = false
      let startX
      let scrollLeft

      thumbsNav.addEventListener('mousedown', (e) => {
        isDown = true
        thumbsNav.style.cursor = 'grabbing'
        startX = e.pageX - thumbsNav.offsetLeft
        scrollLeft = thumbsNav.scrollLeft
        e.preventDefault()
      })

      thumbsNav.addEventListener('mouseleave', () => {
        isDown = false
        thumbsNav.style.cursor = 'grab'
      })

      thumbsNav.addEventListener('mouseup', () => {
        isDown = false
        thumbsNav.style.cursor = 'grab'
      })

      thumbsNav.addEventListener('mousemove', (e) => {
        if (!isDown) {
          return
        }
        e.preventDefault()
        const x = e.pageX - thumbsNav.offsetLeft
        const walk = (x - startX) * 2 // Speed multiplier
        thumbsNav.scrollLeft = scrollLeft - walk
      })

      // Touch events for mobile
      thumbsNav.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX - thumbsNav.offsetLeft
        scrollLeft = thumbsNav.scrollLeft
      })

      thumbsNav.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX - thumbsNav.offsetLeft
        const walk = (x - startX) * 2
        thumbsNav.scrollLeft = scrollLeft - walk
        e.preventDefault()
      })
    }
  }
}, 500)
